import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";

import PrimaryButton from "@/components/UI/PrimaryButton/PrimaryButton";
import SecondaryButton from "@/components/UI/SecondaryButton/SecondaryButton";
import { setSimpleValue } from "@/store/actions";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 16,
    height: "114px",
    padding: "19px 16px",
    backgroundColor: "#161616",
    width: "100%",
  },
  title: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: "#fff",
  },
  buttons: {
    width: "272px",
    gap: "32px",
    display: "flex",
    justifyContent: "space-between",
  },
});

export default function DeleteElement(props) {
  const { element, onRemove } = props;
  const classes = useStyles();

  const dispatch = useDispatch();

  return (
    <div className={classes.container} data-testid="delete-element-container">
      <span className={classes.title}>Are you sure you want to remove this element?</span>
      <div className={classes.buttons}>
        <SecondaryButton
          onClick={() => dispatch(setSimpleValue("selectedElementId", null))}
          style={{ width: "max-content" }}
          data-testid="cancel-element-button"
        >
          Cancel
        </SecondaryButton>
        <PrimaryButton
          onClick={() => onRemove(element)}
          style={{ width: "max-content" }}
          data-testid="remove-element-button"
        >
          Remove
        </PrimaryButton>
      </div>
    </div>
  );
}
